const AU_BIFROST_CLIENT_ID = "client_nS2tRQcmWRl_nlRs4AKwBA";

const AU_GLOBAL_SERVICE_BASE_URL = "https://stage-consumer-web-au.qac24svc.dev";

export const getBifrostAuthServiceBaseUrl = () => {
    if (process.env.BIFROST_AUTH_SERVICE_BASE_URL) {
        return process.env.BIFROST_AUTH_SERVICE_BASE_URL;
    }

    switch (process.env.HOST_ENV) {
    case "PRODUCTION":
        return "https://auth.cars24.com.au";
    case "STAGING":
    case "LNOD":
        return "https://auth-service-stage.qac24svc.dev";
    case "QA":
    default:
        return "https://auth-service-stage.qac24svc.dev";
    }
};

export const getBifrostClientId = () => process.env.BIFROST_CLIENT_ID || AU_BIFROST_CLIENT_ID;

export const getBifrostRedirectUri = () => {
    if (process.env.BIFROST_REDIRECT_URI) {
        return process.env.BIFROST_REDIRECT_URI;
    }

    switch (process.env.HOST_ENV) {
    case "PRODUCTION":
        return "https://www.cars24.com.au/auth/callback";
    default:
        return `${AU_GLOBAL_SERVICE_BASE_URL}/auth/callback`;
    }
};

// /auth/token and /auth/logout are handled by the Cloudflare global service, not Express
export const getGlobalServiceBaseUrl = () => {
    if (process.env.HOST_ENV === "PRODUCTION") {
        return ""; // same-origin — AU global service handles it
    }
    return AU_GLOBAL_SERVICE_BASE_URL;
};
